import {NavigateFunction} from 'react-router'

import {
  DynamicProductionTime,
  EditProviderInfoTab,
  InvoicesTab,
  Price,
  PricingTab,
  ProviderInfo,
  ProviderInfoFilterLocationState,
  SettingsTab,
} from '../types'

import {Order, OrderDetailTab, OrderId} from '../order-types'
import ROUTES from '../routes'

export const goToIndex = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.INDEX, {replace})

// Order pages
export const goToOrders = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.ORDERS, {replace})

export const goToOrderDetail = (
  navigate: NavigateFunction,
  {
    orderId,
    activeTab,
    order,
    replace = false,
  }: {
    orderId: OrderId
    activeTab: OrderDetailTab
    order?: Order
    replace?: boolean
  }
) =>
  navigate(`${ROUTES.ORDER_DETAIL.replace(':id', orderId)}/${activeTab}`, {
    state: {order},
    replace,
  })

// Invoices
export const goToInvoices = (
  navigate: NavigateFunction,
  {
    activeTab,
    replace = false,
  }: {
    activeTab: InvoicesTab
    replace?: boolean
  }
) => navigate(`${ROUTES.INVOICES}/${activeTab}`, {replace})

// Catalog table pages
export const goToProviderInfos = (
  navigate: NavigateFunction,
  {
    initialFilters,
    replace = false,
  }: {
    initialFilters?: ProviderInfoFilterLocationState
    replace?: boolean
  } = {}
) => navigate(ROUTES.PROVIDER_INFOS, {state: {initialFilters}, replace})

export const goToCreateProviderInfo = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.CREATE_PROVIDER_INFO, {replace})

export const goToEditProviderInfo = (
  navigate: NavigateFunction,
  {
    providerInfos,
    activeTab,
    replace = false,
  }: {
    providerInfos: ProviderInfo[]
    activeTab: EditProviderInfoTab
    replace?: boolean
  }
) => navigate(`${ROUTES.EDIT_PROVIDER_INFO}/${activeTab}`, {state: {providerInfos}, replace})

export const goToPricings = (
  navigate: NavigateFunction,
  {activeTab, replace = false}: {activeTab: PricingTab; replace?: boolean}
) => navigate(`${ROUTES.PRICINGS}/${activeTab}`, {replace})

export const goToCreatePricing = (
  navigate: NavigateFunction,
  {
    activeTab,
    price,
    replace = false,
  }: {
    activeTab: PricingTab
    price?: Price
    replace?: boolean
  }
) => navigate(`${ROUTES.CREATE_PRICING}/${activeTab}`, {state: {price}, replace})

export const goToEditPricing = (
  navigate: NavigateFunction,
  {
    pricings,
    replace = false,
  }: {
    pricings: Price[]
    replace?: boolean
  }
) => navigate(ROUTES.EDIT_PRICING, {state: {pricings}, replace})

export const goToInfills = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.INFILLS, {replace})

export const goToProductionTimes = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.PRODUCTION_TIMES, {replace})

export const goToDynamicProductionTimes = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.DYNAMIC_PRODUCTION_TIMES, {replace})

export const goToCreateDynamicProductionTime = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.CREATE_DYNAMIC_PRODUCTION_TIMES, {replace})

export const goToEditDynamicProductionTime = (
  navigate: NavigateFunction,
  {
    dynamicProductionTimes,
    replace = false,
  }: {
    dynamicProductionTimes: DynamicProductionTime[]
    replace?: boolean
  }
) => navigate(ROUTES.EDIT_DYNAMIC_PRODUCTION_TIMES, {state: {dynamicProductionTimes}, replace})

export const goToShippings = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.SHIPPINGS, {replace})

export const goToDiscounts = (
  navigate: NavigateFunction,
  {replace = false}: {replace?: boolean} = {}
) => navigate(ROUTES.DISCOUNTS, {replace})

// Account pages
export const goToSettings = (
  navigate: NavigateFunction,
  {
    activeTab,
    replace = false,
  }: {
    activeTab: SettingsTab
    replace?: boolean
  }
) => navigate(`${ROUTES.SETTINGS}/${activeTab}`, {replace})

export type FromLocationState = {
  from?: string
}

export const goToSignIn = (
  navigate: NavigateFunction,
  {
    locationState: state,
    replace = false,
  }: {
    locationState?: FromLocationState
    replace?: boolean
  } = {}
) => navigate(ROUTES.SIGN_IN, {state, replace})

export const goToSignInAdmin = (
  navigate: NavigateFunction,
  {
    locationState: state,
    replace = false,
  }: {
    locationState?: FromLocationState
    replace?: boolean
  } = {}
) => navigate(ROUTES.SIGN_IN_ADMIN, {state, replace})

export const goToResetPassword = (
  navigate: NavigateFunction,
  {
    locationState: state,
    replace = false,
  }: {
    locationState?: FromLocationState
    replace?: boolean
  } = {}
) => navigate(ROUTES.RESET_PASSWORD, {state, replace})
